import { Partial } from '@40seas/entities/common';
import { CreditSafePortfolioEventRule } from './credit-safe-portfolio.event-rule.entity';

export class UpdateCreditSafePortfolioEventRuleDto extends Partial(CreditSafePortfolioEventRule) {}
